/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
(function () {
    'use strict';
    angular.module('vcclient')
        .component('diagnosesedit', {
            restrict: 'E',
            bindings: {
                diagnoses: '=',
                deleteddiagnoses: '=',
                parentsave: '&',
                orderbycolor: '<',
                customlabels: '<?',
                printlabels: '<?',
                deleteable: '@?'
            },
            templateUrl: 'vcclient/diagnosesedit-component.tpl.html',
            controllerAs: 'vm',
            controller: ['$log',
                function ($log) {
                    let vm = this;

                    vm.orderkey = 'nr';
                    vm.save = save;
                    vm.updateColor = updateColor;
                    vm.addKeyword = addKeyword;
                    vm.editKeyword = editKeyword;
                    vm.removeKeyword = removeKeyword;
                    vm.updateInvoiceVisibility = updateInvoiceVisibility;

                    vm.sortableOptions = {
                        itemMoved: function (event) {
                            $log.debug('diagnose moved: ', event);
                            save();
                        },
                        orderChanged: function (event) {
                            $log.debug('diagnose order changed: ', event);
                            save();
                        },
                    };

                    function nrResolver(col) {
                        let nrR = {
                            primary: 1,
                            info: 2,
                            danger: 3,
                            warning: 4,
                            success: 5
                        };
                        return nrR[col];
                    }


                    vm.$onInit = function () {
                        if (angular.isUndefined(vm.customlabels)) {
                            vm.customlabels = {
                                primary: 'Neu',
                                info: 'Aktuell',
                                danger: 'Gefahr',
                                warning: 'Warnung',
                                success: 'St.p.'
                            };
                        }
                        if (angular.isUndefined(vm.printlabels)) {
                            vm.printlabels = {
                                primary: '(neu)',
                                info: '',
                                danger: '',
                                warning: '',
                                success: '(St.p.)'
                            };
                        }
                        // $log.debug('diagnoseedit diagnoses: ', vm.diagnoses);
                    };

                    function updateColor(kw, color) {
                        kw.col = color;
                        kw.nr = nrResolver(color);
                        kw.alttext = vm.printlabels[color];
                        kw.updated = moment().locale('de-at').format('l');
                        save();
                    }

                    function removeKeyword(kw, index) {
                        // $log.debug('deleting diagnose: ', index, kw);
                        kw.active = false;
                        kw.timestamp = moment().toISOString();
                        kw.removed = moment().locale('de-at').format('l');
                        vm.diagnoses.splice(index, 1);
                        vm.deleteddiagnoses.push(kw);
                        // $log.debug('after diagnose delete: ', vm.diagnoses, vm.deleteddiagnoses);
                        save();
                    }

                    function addKeyword() {
                        if (angular.isDefined(vm.newkeyword) && vm.newkeyword.length > 0) {
                            let kw = {};
                            kw.col = 'primary';
                            kw.key = vm.newkeyword;
                            kw.nr = nrResolver(kw.col);
                            kw.alttext = vm.printlabels[kw.col];
                            kw.timestamp = moment().toISOString();
                            kw.created = moment().locale('de-at').format('l');
                            kw.updated = moment().locale('de-at').format('l');

                            if (!angular.isArray(vm.diagnoses)) {
                                vm.diagnoses = [];
                            }
                            vm.diagnoses.push(kw);

                            vm.newkeyword = '';
                            save();
                        }
                    }

                    function editKeyword(kw) {
                        kw.timestamp = moment().toISOString();
                        kw.updated = moment().locale('de-at').format('l');
                        $log.debug('edited kw: ', kw);
                        save();
                    }

                    function updateInvoiceVisibility(kw) {
                        save();
                    }

                    function save() {
                        // $log.debug('debug: diagnosesedit save called: ', vm.diagnoses,  vm.lastdiagnoses);
                        // $log.debug('debug: diagnosesedit save called: ', vm.diagnoses, vm.deleteddiagnoses);
                        //   $log.debug('***: diagnoseedit calling parentsave: ', vm.parentsave, vm.deleteddiagnoses);
                        vm.parentsave();
                    }


                }] // controller
        }); // component

// klammerfriedhof
}());
